<div class="action-bar">
    <div class="date-picker">
        <nb-action>
            <nb-select placeholder="Date Range" 
                       [(ngModel)]="dateRange" 
                       (ngModelChange)="onDateRangeChange()">
                <nb-option value="day">Day</nb-option>
                <nb-option value="week">Week</nb-option>
                <nb-option value="month">Month</nb-option>
                <nb-option value="custom">Custom</nb-option>
            </nb-select>
        </nb-action>
        <button *ngIf="dateRange!='custom'" 
                nbButton 
                (click)="goPrev()" 
                class="mr-2" 
                status="basic"
                [nbTooltip]="prevButtonTooltip"
                nbTooltipPlacement="top">
            <nb-icon icon="arrow-ios-back-outline"></nb-icon>
        </button>

        <input class='filter-input' 
               nbInput 
               [(ngModel)]="startDate" 
               (ngModelChange)="onStartDateChange($event)"
               placeholder="Pick Date From" 
               [nbDatepicker]="dateTimePickerStart">
        <nb-date-timepicker format="dd MMM yyyy  HH:mm" 
                            #dateTimePickerStart 
                            singleColumn 
                            [step]="30"></nb-date-timepicker>

        <input class='filter-input' 
               nbInput 
               [(ngModel)]="endDate" 
               (ngModelChange)="onEndDateChange($event)"
               placeholder="Pick Date To" 
               [nbDatepicker]="dateTimePickerEnd">
        <nb-date-timepicker #dateTimePickerEnd 
                            format="dd MMM yyyy  HH:mm" 
                            singleColumn 
                            [step]="30"></nb-date-timepicker>

        <button *ngIf="dateRange!='custom'" 
                nbButton 
                (click)="goNext()" 
                status="basic"
                [nbTooltip]="nextButtonTooltip"
                nbTooltipPlacement="top"
                [disabled]="isNextButtonDisabled">
            <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
        </button>
    </div>

    <div class="action-buttons">
        
        <button *ngIf="dateRange === 'custom' && config.showFilterButton !== false" 
                nbButton 
                class="action-button" 
                status="primary" 
                (click)="onFilterClick()">
            {{ config.filterButtonLabel || 'Filter' }}
        </button>
    </div>
</div>

